import { render, staticRenderFns } from "./TestDrive.vue?vue&type=template&id=04834dc6&scoped=true"
import script from "./TestDrive.vue?vue&type=script&lang=js"
export * from "./TestDrive.vue?vue&type=script&lang=js"
import style0 from "./TestDrive.vue?vue&type=style&index=0&id=04834dc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04834dc6",
  null
  
)

export default component.exports